export const flex = {
    display: "flex",
};
export const centered = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
};
export const between = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
};
export const jEnd = {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
};
export const rowCenter = {
    display: "flex",
    justifyContent: "center",
};
export const colCenter = {
    display: "flex",
    alignItems: "center",
};
export const stack2 = {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
};
export const stack2_5 = {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
};
export const stack3 = {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
};
export const gridWraper = {
    boxShadow: "0px 8px 16px 0px #919EAB29",
    padding: "12px",
};
export const colEnd = {
    display: "flex",
    alignItems: "end",
};
export const filterButton = {
    background: "#919EAB14",
    color: "black",
};
export const ellipsis = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "block",
};
